import Model from '@/models/Model.js';

export default class ActivitySubmission extends Model {
    static entity = 'activity_submissions';

    static modelName = 'ActivitySubmission';

    static fields() {
        return {
            id: this.attr(null),
            course_id: this.attr(null),
            activity_id: this.attr(null),
            attempt: this.attr(null),
            submittable_id: this.attr(null),
            submittable_type: this.attr(null),
            marked_completed_at: this.attr(null),
            created_by: this.attr(null),
            updated_by: this.attr(null),

            ...super.fields(),

            course: this.belongsTo('courses', 'course_id'),
            activity: this.belongsTo('activities', 'activity_id'),
            submittable: this.morphTo('submittable_id', 'submittable_table'),
            gradebook_grades: this.hasMany('gradebook_grades', 'gradebook_grades_id'),
        };
    }
}
